import React from 'react';
import { useFlashcards } from '../../hooks/useFlashcards';
import { useCourseData } from '@/pages/Course';
import { ScrollArea } from '@/components/ui/scroll-area';
import QuizItem from './QuizItem';
import CreateFlashCard from './CreateFlashCard';

function FlashCard({ course }) {
  const { isAdmin } = useCourseData();

  // ✅ Fetch flashcards
  const { getFlashcards } = useFlashcards(course._id);
  const {
    data: flashCardsData,
    error,
    isLoading,
    refetch,
  } = getFlashcards;

  if (isLoading) return <p>Loading flashcards...</p>;
  if (error) return <p>Error loading flashcards: {error.message}</p>;

  // ✅ Properly assign flashCards variable
  const flashCards =
    flashCardsData?.data?.flashCards ||
    flashCardsData?.flashCards ||
    flashCardsData?.data ||
    flashCardsData ||
    [];

  return (
    <ScrollArea className="h-full">
      <div className="space-y-8">
        {isAdmin && <CreateFlashCard course={course} refetch={refetch} />}

        <div className="grid sm:grid-cols-2 md:grid-cols-3 px-1 gap-2 pb-10">
          {Array.isArray(flashCards) && flashCards.length > 0 ? (
            flashCards.map((flashCard) => (
              <div className="p-2" key={flashCard._id}>
                <QuizItem flashCard={flashCard} />
              </div>
            ))
          ) : (
            <p className="text-center text-gray-400 py-4">
              No flashcards found for this course.
            </p>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}

export default React.memo(FlashCard);
